/// <amd-module name="Release/DeploymentsSection/Actions/SignalR" />
import { Action } from "VSS/Reflux/Action";
import { ReleaseEnvironmentStatusUpdatedEvent, EnvironmentStatus, DeploymentStatus, DeploymentOperationStatus } from "Release/Client/Contracts/Release";

export interface ISignalRActionCreatorProps {
    actionHub: DeploymentsSignalRActionHub;
}

export class DeploymentsSignalRActionCreator {
    private _actionHub: DeploymentsSignalRActionHub;

    public constructor(options: ISignalRActionCreatorProps) {
        this._actionHub = options.actionHub;
    }

    public environmentUpdated(projectId: string, definitionId: number, releaseId: number, environmentId: number, environmentStatus: EnvironmentStatus,
                                deploymentStatus: DeploymentStatus, deploymentOperationStatus: DeploymentOperationStatus) {
        const releaseEnvironmentStatusUpdatedEvent:ReleaseEnvironmentStatusUpdatedEvent =  {
            definitionId: definitionId,
            environmentId: environmentId,
            environmentStatus: environmentStatus,
            projectId: projectId,
            releaseId: releaseId,
            latestDeploymentStatus: deploymentStatus,
            latestDeploymentOperationStatus: deploymentOperationStatus
        };
        
        this._actionHub.environmentUpdated.invoke(releaseEnvironmentStatusUpdatedEvent);
    }

    public get actionHub() {
        return this._actionHub;
    }
}

export class DeploymentsSignalRActionHub {
    private _environmentUpdated: Action<ReleaseEnvironmentStatusUpdatedEvent>;

    constructor() {
        this._environmentUpdated = new Action<ReleaseEnvironmentStatusUpdatedEvent>();
    }

    public get environmentUpdated(): Action<ReleaseEnvironmentStatusUpdatedEvent> {
        return this._environmentUpdated;
    }
}